import React, { Component } from 'react';
import styles from './Wireframe.scss';

class Wireframe extends Component {
  render() {
    return (
      <div className={styles.SuggestionsWireframe}>
          <div className={styles.Container}>
              <div className={styles.SuggestionsTitle}>
                  <div className={styles.Title}></div>
              </div>
              <div className={styles.SuggestionsCards}>
                  <div className={styles.SuggestionsCard}></div>
                  <div className={styles.SuggestionsCard}></div>
                  <div className={styles.SuggestionsCard}></div>
                  <div className={styles.SuggestionsCard}></div>
              </div>
          </div>

      </div>
    )
  }
}

export default Wireframe;



// WEBPACK FOOTER //
// ./src/components/Building/Main/SuggestionsWireframe/Wireframe.js